import { Transition } from '@headlessui/react'
import { useMemo } from 'react'
import ReactCountryFlag from 'react-country-flag'

export interface UserItemProps {
    firstName: string
    email: string
    lastName: string
    phone: string
    lastLoginDate: string
    notifyPhone: Boolean
    notifyEmail: Boolean
    role: string
    country: { name: string; abbreviation: string }
    id: number
}

export function UserItem({
    firstName,
    lastName,
    email,
    notifyPhone,
    notifyEmail,
    phone,
    role,
    lastLoginDate,
    country,
}: UserItemProps) {
    const initial = useMemo(() => {
        return firstName ? firstName[0].toUpperCase() : 'C'
    }, [firstName])

    const lastLogin = useMemo(() => {
        if (lastLoginDate) {
            const date = new Date(lastLoginDate)
            return date.toLocaleString()
        }

        return 'No last login'
    }, [lastLoginDate])
    return (
        <Transition
            show={true}
            enter='transition ease-in-out duration-700 transform'
            enterFrom='translate-x-full'
            enterTo='translate-x-0'
            leave='transition ease-in-out duration-700 transform'
            leaveFrom='translate-x-0'
            leaveTo='translate-x-full'
            className={`${'animate-enter'} relative cursor-pointer hover:bg-gray2 w-full bg-white shadow-lg rounded-md pointer-events-auto flex ring-1 ring-black ring-opacity-5`}>
            <div className='flex flex-row items-center w-full gap-8 p-8'>
                <div className='flex flex-col items-center w-1/3'>
                    <div className='flex items-center justify-center w-16 h-16 text-xl font-bold text-white bg-black rounded-full'>
                        {initial}
                    </div>
                    <p className='mt-2'>{role?.toLowerCase() ?? 'borrower'}</p>

                    <div className='flex flex-row justify-center w-full gap-4 mt-2'>
                        {notifyPhone && <p className='text-center'>📱</p>}
                        {notifyEmail && <p className='text-center'>📧</p>}
                    </div>
                </div>
                <div>
                    <div>
                        <ReactCountryFlag
                            className='absolute m-0 mr-4 top-4 right-4'
                            countryCode={country?.abbreviation}
                            style={{
                                fontSize: '3em',
                                lineHeight: '1em',
                            }}
                        />
                        <h2 className='m-0 font-bold text-black'>
                            {firstName}
                        </h2>
                        <h2 className='m-0 font-bold text-black'>{lastName}</h2>
                    </div>
                    <p>
                        <span className='mr-2'>✉️</span>
                        {email}
                    </p>

                    <p>
                        <span className='mr-2'>📞</span>
                        {phone}
                    </p>
                    <p>
                        <span className='mr-2'>🕐</span>
                        {lastLogin}
                    </p>
                </div>
            </div>
        </Transition>
    )
}
